/*
 * routes - which components to display at which urls
 * by ole fjarestad
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DashboardComponent } from '../dashboard/dashboard.component';
import { DocumentsComponent } from '../documents/documents.component';
// import { DocumentDetailComponent } from './document-detail.component';
import { DocumentComponent } from '../document/document.component';
import { ClientsComponent } from '../clients/clients.component';
import { ClientComponent } from '../client/client.component';
import { LoginComponent } from '../login/login.component';
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';
// import { UserGuardService } from '../user-guard.service';
import { UserAuthService } from '../user-auth.service';

const routes: Routes = [
	{
		// login screen (always available)
		path: 'login', // login screen
		component: LoginComponent,
	},
	{
		// logout screen (always available)
		path: 'logout', // login screen
		component: LoginComponent,
	},
        {
		// forgot password (always available)
		path: 'forgot-password', // forgot-password screen
		component: ForgotPasswordComponent,
	},
	{ // protected paths that are only available when logged in
		path: '',
		// canActivate: [UserGuardService],
		canActivate: [UserAuthService],
		children: [
			{
				path: 'clients', // clients listing
				redirectTo: 'clients/all',
				pathMatch: 'full',
			},
			{
				path: 'clients/:action', // clients listing with *insert action here* at the end of url (action can be e.g. "all" or "mine")
				component: ClientsComponent,
			},
			{
				path: 'client/:id', // client single (aka bedriftskort)
				component: ClientComponent,
			},
			{
				path: 'client/:id/:action', // client single (aka bedriftskort) with *insert action here* at the end of url (action can be e.g. "create" or "edit")
				component: ClientComponent,
			},
			{
				path: 'documents', // documents listing
				component: DocumentsComponent,
			},
			{
				path: 'documents/:action', // documents listing with *insert action here* at the end of url (action can be e.g. "all" or "mine")
				component: DocumentsComponent,
			},
			{
				path: 'document/:id', // document single
				component: DocumentComponent,
			},
			{
				path: '', // dashboard
				redirectTo: 'clients/all',
				pathMatch: 'full',
				// component: DashboardComponent,
			},
			{ // no matching paths will display dashboard #RPT: in the future
				path: '**',
				redirectTo: 'clients/all',
				pathMatch: 'full',
				// component: DashboardComponent,
			},
		],
	},
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ],
  // providers: [ UserGuardService ],
  providers: [ UserAuthService ],
})

export class AppRoutingModule {}


// WEBPACK FOOTER //
// ./src/app/app-routing/app-routing.module.ts